import { Injectable } from '@angular/core'
import { Channel, DialogService } from '@tokeet-frontend/tv3-platform'
import { ConnectionView } from '@tv3/store/connection/connection.view'
import { MatDialogConfig } from '@angular/material/dialog'
import { BdcPropertyDetailDialogComponent, BdcPropertyDetailDialogTab } from './bdc-property-detail-dialog.component'

@Injectable()
export class BdcPropertyDetailDialogService {
  constructor(private dialog: DialogService) {}

  open(
    channel: Channel,
    connection: ConnectionView,
    activeTab: BdcPropertyDetailDialogTab = BdcPropertyDetailDialogTab.Details
  ) {
    const defaultConfig: MatDialogConfig = {
      data: { channel, connection, activeTab },
      panelClass: ['drawer-full-80'],
    }

    const dialogRef = this.dialog.openDrawer(BdcPropertyDetailDialogComponent, defaultConfig)

    return dialogRef
  }
}
